<lib-file-info (fileRenamed)="fileOperationsHelperService.confirmOperation($event)"/>
<!-- <app-change-access-confirmation (confirmFileOpn)="fileOperationsHelperService.confirmFileOpn($event)"/> -->
<!-- <app-private-share (setShare)="fileOperationsHelperService.confirmShareOperation($event)"/> -->
<app-enhanced-share-link/>
<common-manage-version/>
<app-add-to-album
  [enableButton]="fileOpsImplementationRef.enableButton"
  (close)="fileOperationsHelperService.close()"
  (createNewAlbum)="fileOperationsHelperService.createNewAlbum()"
  (closecreateModal)="fileOperationsHelperService.closeCreateModal()"
  (gotoPreviousScreen)="fileOperationsHelperService.goBackToPreviousScreen()"
  (createAlbumValidation)="fileOperationsHelperService.validateBeforeCreatingAlbum($event)"
  />
<!-- <app-move-copy
  [enableButton] = "fileOpsImplementationRef.enableButton"
  (close)="fileOperationsHelperService.close()"
  (createNewFolder)="fileOperationsHelperService.createNewFolder()"
  (removeFolderKeys)="fileOperationsHelperService.removeFolderKeys()"
  (fetchNestedFolderData)="fileOperationsHelperService.fetchNestedFoldersData($event)"
  (fetchNestedFolderDataForMobile)="fileOperationsHelperService.fetchNestedFoldersDataForMobile($event)"
  (fetchNestedFolderDataForShared)="fileOperationsHelperService.fetchNestedFolderDataForShared($event)"
  (fetchNestedFolderDataForTeamFolder)="fileOperationsHelperService.fetchNestedFolderDataForTeamFolder($event)"
  (fetchNestedFolderDataForTeamFolderMobile)="fileOperationsHelperService.fetchNestedFolderDataForTeamFolderMobile($event)"
  (fetchNestedFolderDataForMobileShared)="fileOperationsHelperService.fetchNestedFolderDataForMobileShared($event)"
  (closecreateModal)="fileOperationsHelperService.closeCreateModal()"
  (gotoPreviousScreen)="fileOperationsHelperService.goBackToPreviousScreen()"
  (createFolderValidation)="fileOperationsHelperService.validateBeforeCreatingFolder($event)"
  (confirmMove)="fileOperationsHelperService.confirmOperation($event)"
  (confirmCopy)="fileOperationsHelperService.confirmOperation($event)"
  /> -->
<!-- <app-add-hash-tag/> -->
<!-- <app-delete-items (confirmDeletion)="fileOperationsHelperService.confirmOperation($event)" (close)="fileOperationsHelperService.close()"/> -->
@if (universalService.popUpToBeOpened == 'shareDiscardPopUp') {
  <app-share-discard (close)="fileOperationsHelperService.close()"/>
}
<!-- <app-rename (confirmRename)="fileOperationsHelperService.confirmOperation($event)" (close)="fileOperationsHelperService.close()"/> -->
<app-share-link (close)="fileOperationsHelperService.close()"/>
<!-- <app-create-folder
  [enableButton] = "fileOpsImplementationRef.enableButton"
  (closecreateModal)="fileOperationsHelperService.closeCreateModal()" (createFolderMove)="fileOperationsHelperService.createFolderAndMove()"
  (createFolderValidation)="fileOperationsHelperService.validateBeforeCreatingFolder($event)" (createFolderCopy)="fileOperationsHelperService.createFolderAndCopy()"
  (gotoPreviousScreen)="fileOperationsHelperService.goBackToPreviousScreen()"
  /> -->
<!-- <app-move-to-private-folder/> -->